import React from 'react';
import { Link } from "react-router-dom";
import Auth from "../../services/Auth.service";
import { useTranslation } from "react-i18next";
import NavegacionFarms from "../../components/NavigableComponents/NavigableFarms";
import BotonesNavegacionNaves from "../../components/ButtonComponentsPanel/CustomButtonsRedirectShips";
import NavesAlternanciaComponents from "../../components/NavesComponents/NavesAlternanciaComponents";
export default function AlternationNaves() {

    const { t } = useTranslation();

    return (
        <div>
            {Auth.isUserLoged ? <div>
                <br />
                <div className="container-fluid">
                    <div className="col-12 col-lg-11 mx-auto">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to={'/home/'}>{t("Home_Breadcrumb_Title")}</Link></li>
                                    <li className="breadcrumb-item"><Link to={'/Groups/'}>{t("Global_Label_Text_Groups")}</Link></li>
                                    <li className="breadcrumb-item"><Link to={'/Naves/'}>{t("Global_Label_Text_Ships")}</Link></li>
                                    <li className="breadcrumb-item"><Link to={'/AlternationNaves/'}>{t("Global_Label_Text_Alternation")}</Link></li>
                                </ol>
                            </nav>
                            <NavegacionFarms />
                        </div>
                    </div>
                </div>

                <div>
                    <div>
                        <BotonesNavegacionNaves />
                    </div>
                    <div>
                        <NavesAlternanciaComponents />
                    </div>
                </div>
                <br />
            </div > : ""}
        </div>
    );

}
